import { usePageMeta } from "@/lib/meta";
import { HtmlBlock } from "@/components/HtmlBlock";
import html from "@/gen/why_we_exist";

export default function WhyWeExistPage() {
  usePageMeta("Why We Exist");
  return <HtmlBlock html={html} testId="why-we-exist-page" />;
}
